<template>
  <v-card
    v-if="$can('view', 'Yacht')"
    class="elevation-10 radius-10 mt-12"
  >
    <v-card-title class="subtitle-1">
      {{ yacht.model.full_name }} Photos
    </v-card-title>
    <v-divider />
    <v-card-text class="pa-0">
      <v-row>
        <v-col
          v-for="photo in yachtModelPhotos"
          :key="photo.id"
          cols="4"
          @click="previewImage(photo.path)"
        >
          <v-card
            flat
            tile
            class="d-flex"
          >
            <v-img
              :src="photo.path"
              aspect-ratio="1"
              class="grey lighten-2"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex'
import File from '@/models/File'

export default {
  name: 'Photos',
  props: {
    yacht: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    yachtModelPhotos() {
      return this.yacht.model.files.filter(f => f.category === File.CATEGORY_PHOTO)
    }
  },
  methods: {
    ...mapActions(['previewImage'])
  }
}
</script>

<style scoped>

</style>
